var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "Layer_56",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("polyline", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { points: "40.448 89.615 49.002 89.615 59.389 89.615" },
      }),
      _c("polyline", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { points: "50.029 89.619 50.029 89.609 50.029 81.539" },
      }),
      _c("polyline", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { points: "59.615 89.613 51.061 89.613 40.674 89.613" },
      }),
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { x1: "50.029", y1: "89.609", x2: "50.029", y2: "81.539" },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m55.959,73.159c-1.77.63-3.26,1.78-4.3,3.25-1.03,1.46-1.63,3.24-1.63,5.13,0-1.89-.59-3.67-1.63-5.13-1.03-1.47-2.51-2.62-4.29-3.25-5.18-1.83-8.16-7.25-6.94-12.61l2.3-10.5c.92-4.22,1.26-8.54,1.01-12.85l-.97-16.73c-.03-.57.42-1.06,1-1.06h19.05c.57,0,1.03.49.99,1.06l-.97,16.73c-.25,4.31.09,8.63,1.02,12.85l2.29,10.5c1.23,5.35-1.75,10.78-6.93,12.61Z",
        },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m40.5,34.604l1.926.712c2.724,1.007,5.77.596,8.129-1.099h0c2.221-1.596,5.062-2.06,7.676-1.253l1.043.322",
        },
      }),
      _c("polyline", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { points: "47.608 55.283 52.323 12.766 61.482 11.354" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }